import createReducer, { ActionCreatorHelper } from '@hh.ru/redux-create-reducer';

import VacancyEditEvent from 'src/constants/vacancyEditEvent';
import VacancyPublicationType from 'src/constants/vacancyPublicationType';
import VacancyServiceType from 'src/constants/vacancyServiceType';

import { AnalyzeResultType } from 'src/models/competitorAnalysisForVacancy';

export interface ConversionStatisticsReportParams {
    vacancyId: number;
    startDate?: string;
    endDate?: string;
}

export enum ComparisonResult {
    LOWER = 'LOWER',
    HIGHER = 'HIGHER',
}
export interface ConversionStatisticsReport {
    vacancyId: number;
    startDate: string;
    endDate: string;
    vacancyCreationDate: string;
    vacancyExpirationDate: string;
    vacancyName: string;
    viewCount: number;
    responseCount: number;
    searchCount: number;
    viewToResponseConversion: number;
    viewToResponseConversionComparison: {
        comparisonResult: ComparisonResult;
        value: number;
    } | null;
    points: Array<Point>;
    services: Array<Service>;
    publications: Array<Publication>;
    isArchived: boolean;
    vacancyAreaName: string;
    analyzeResultType: AnalyzeResultType;
}

export interface Point {
    date: string;
    viewCount: number;
    responseCount: number;
    editEvents: Array<VacancyEditEvent>;
    activeServices: Array<string>;
    publicationEvents: {
        publicationType: VacancyPublicationType;
        publicationCount: number;
    };
    /**
     * Фейковая точка для расширения графика
     */
    isFake?: boolean;
}

export interface Service {
    service: VacancyServiceType;
    startDate: string;
    endDate: string;
}

export interface Publication {
    prolongations: string[];
    startDate: string;
    publicationType: VacancyPublicationType;
}

const INITIAL_STATE: ConversionStatisticsReport = {
    vacancyId: 0,
    startDate: '',
    endDate: '',
    vacancyName: '',
    viewCount: 0,
    responseCount: 0,
    searchCount: 0,
    viewToResponseConversion: 0,
    viewToResponseConversionComparison: null,
    points: [],
    services: [],
    publications: [],
    vacancyCreationDate: '',
    vacancyExpirationDate: '',
    isArchived: false,
    vacancyAreaName: '',
    analyzeResultType: AnalyzeResultType.NotEnoughData,
};

const SET_CONVERSION_STATISTICS = 'SET_CONVERSION_STATISTICS';

interface PayloadTypes {
    [SET_CONVERSION_STATISTICS]: ConversionStatisticsReport;
}

const actionCreator = ActionCreatorHelper<PayloadTypes>();
export const setConversionStatistics = actionCreator(SET_CONVERSION_STATISTICS);

export default createReducer<ConversionStatisticsReport, PayloadTypes>(INITIAL_STATE, {
    [SET_CONVERSION_STATISTICS]: (state, { payload }) => ({
        ...payload,
        analyzeResultType: state.analyzeResultType,
        vacancyAreaName: state.vacancyAreaName,
    }),
});
